export default {
    header: '#5a53ab',
    footer: '#fbd542',
    headerlinks: '#4eb74e',
    titlesbg: '#ff7e7e',
    pbg: '#e6b806',
}